var galleryTmpl = '<!-- Root element of PhotoSwipe. Must have class pswp. --> \
                <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">  \
                    <!-- Background of PhotoSwipe.  \
                         Its a separate element as animating opacity is faster than rgba(). --> \
                    <div class="pswp__bg"></div> \
                    <!-- Slides wrapper with overflow:hidden. --> \
                    <div class="pswp__scroll-wrap">  \
                        <!-- Container that holds slides.  \
                            PhotoSwipe keeps only 3 of them in the DOM to save memory. \
                            Dont modify these 3 pswp__item elements, data is added later on. --> \
                        <div class="pswp__container"> \
                            <div class="pswp__item"></div> \
                            <div class="pswp__item"></div> \
                            <div class="pswp__item"></div> \
                        </div> \
                        <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. --> \
                        <div class="pswp__ui pswp__ui--hidden"> \
                            <div class="pswp__top-bar"> \
                                <!--  Controls are self-explanatory. Order can be changed. --> \
                                <div class="pswp__counter"></div> \
                                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button> \
                                <button class="pswp__button pswp__button--share" title="Share"></button> \
                                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button> \
                                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button> \
                                <!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR --> \
                                <!-- element will get class pswp__preloader--active when preloader is running --> \
                                <div class="pswp__preloader"> \
                                    <div class="pswp__preloader__icn"> \
                                      <div class="pswp__preloader__cut"> \
                                        <div class="pswp__preloader__donut"></div> \
                                      </div> \
                                    </div> \
                                </div> \
                            </div> \
                            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"> \
                                <div class="pswp__share-tooltip"></div>  \
                            </div> \
                            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"> \
                            </button> \
                            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"> \
                            </button> \
                            <div class="pswp__caption"> \
                                <div class="pswp__caption__center"></div> \
                            </div> \
                        </div> \
                    </div> \
                </div>';

function gallery_init(selector) {
    jQuery(document.body).append(galleryTmpl);
    initPhotoSwipeFromDOM(selector);
}

function gallery_set_thumb_heights(selector) {
    var elems = jQuery(selector);
    elems.each(function (index, elem) {
        var width = jQuery(elem).width();
        jQuery(elem).css('height', width + 'px');
    });
}

var initPhotoSwipeFromDOM = function (thumbSelector) {
    var gallery;
    var items = null;

    var parseThumbnailElements = function () {
        var elems = jQuery(thumbSelector);
        var thumbs = [];
        elems.each(function (index, item) {
            var thumbImg = jQuery(item).find('img');
            if (thumbImg.length === 0) {
                console.error('there must be an image inside the link');
                return;
            }
            var imgSrc = thumbImg.attr('src');
            var title = thumbImg.attr('alt');

            /* if there is no alt attribute use the fig caption */
            if (title === undefined || title.length === 0) {
                var figCaption = jQuery(item).find('figcaption');
                if (figCaption.length > 0) {
                    title = figCaption.html();
                }
            }
            var imgSize = thumbImg.attr('data-size');
            var imgWidth, imgHeight;
            if (imgSize === 'undefined') {
                var splitSize = imgSize.split('x');
                if (splitSize.length !== 2) {
                    console.error('invalid data size: ' + imgSize);
                    return;
                }
                imgWidth = splitSize[0];
                imgHeight = splitSize[1];
            } else {
                imgWidth = thumbImg[0].naturalWidth;
                imgHeight = thumbImg[0].naturalHeight;
            }
            var thumb = {
                src: imgSrc,
                w: imgWidth,
                h: imgHeight,
                title: title
            };
            thumbs.push(thumb);
        });
        return thumbs;
    };

    var openGallery = function (index) {
        var pswpElement = jQuery('.pswp')[0];
        if (items === null) {
            items = parseThumbnailElements();
        }
        options = {
            index: index,
            fullscreenEl: false,
            zoomEl: false,
            shareEl: false,
            arrowEl: false,
            bgOpacity: 1,
            closeOnScroll: false,
            pinchToClose: false,
            closeOnVerticalDrag: false
        };
        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    };

    var addGalleryClickCallback = function () {
        var elems = jQuery(thumbSelector);
        elems.each(function (index, elem) {
            jQuery(elem).attr('data-index', index);
        });
        elems.unbind("click");
        elems.click(function (e) {
            if (jQuery(e.target).hasClass("imgRemove") || jQuery(e.target).parent().hasClass("imgRemove")) {
                return true;
            }
            e.preventDefault();
            var parent;
            if (e.target.tagName === 'FIGURE') {
                parent = jQuery(e.target);
            } else {
                parent = jQuery(e.target).parent('figure');
            }
            var index = elems.index(parent);

            var vLink = parent.children("img").first().attr("vLink");
            if (vLink) {
                window.location.href = vLink;
            } else {
                openGallery(index);
            }
        });
    };

    addGalleryClickCallback();
};